/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillItemVo
 */
export interface BillItemVo {
    /**
     * ID
     * @type {number}
     * @memberof BillItemVo
     */
    id?: number;
    /**
     * 账单类型
     * @type {number}
     * @memberof BillItemVo
     */
    billType?: number;
    /**
     * 订单编码
     * @type {string}
     * @memberof BillItemVo
     */
    orderCode?: string;
    /**
     * 订单ID
     * @type {number}
     * @memberof BillItemVo
     */
    orderId?: number;
    /**
     * 账单编号
     * @type {string}
     * @memberof BillItemVo
     */
    billCode?: string;
    /**
     * 账单名
     * @type {string}
     * @memberof BillItemVo
     */
    name?: string;
    /**
     * 账单状态
     * @type {number}
     * @memberof BillItemVo
     */
    status?: number;
    /**
     * 退款账单编号列表（仅status=4全额退款时返回；关联退款账单billType=4/20/24/28，按targetId关联，部分退款累计到全额时可能多笔）
     * @type {Array<string>}
     * @memberof BillItemVo
     */
    refundBillCodes?: Array<string>;
    /**
     * 货物收费总金额
     * @type {number}
     * @memberof BillItemVo
     */
    totalGoodsAmount?: number;
    /**
     * 附加服务总金额
     * @type {number}
     * @memberof BillItemVo
     */
    totalAdditionalServiceAmount?: number;
    /**
     * 钱包转账总金额
     * @type {number}
     * @memberof BillItemVo
     */
    totalTransferAmount?: number;
    /**
     * 优惠券抵扣金额
     * @type {number}
     * @memberof BillItemVo
     */
    couponAmount?: number;
    /**
     * 账单总金额
     * @type {number}
     * @memberof BillItemVo
     */
    totalAmount?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof BillItemVo
     */
    createTime?: string;
}

/**
 * Check if a given object implements the BillItemVo interface.
 */
export function instanceOfBillItemVo(value: object): value is BillItemVo {
    return true;
}

export function BillItemVoFromJSON(json: any): BillItemVo {
    return BillItemVoFromJSONTyped(json, false);
}

export function BillItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'billType': json['billType'] == null ? undefined : json['billType'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'billCode': json['billCode'] == null ? undefined : json['billCode'],
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : json['status'],
        'refundBillCodes': json['refundBillCodes'] == null ? undefined : json['refundBillCodes'],
        'totalGoodsAmount': json['totalGoodsAmount'] == null ? undefined : json['totalGoodsAmount'],
        'totalAdditionalServiceAmount': json['totalAdditionalServiceAmount'] == null ? undefined : json['totalAdditionalServiceAmount'],
        'totalTransferAmount': json['totalTransferAmount'] == null ? undefined : json['totalTransferAmount'],
        'couponAmount': json['couponAmount'] == null ? undefined : json['couponAmount'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function BillItemVoToJSON(json: any): BillItemVo {
    return BillItemVoToJSONTyped(json, false);
}

export function BillItemVoToJSONTyped(value?: BillItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'billType': value['billType'],
        'orderCode': value['orderCode'],
        'orderId': value['orderId'],
        'billCode': value['billCode'],
        'name': value['name'],
        'status': value['status'],
        'refundBillCodes': value['refundBillCodes'],
        'totalGoodsAmount': value['totalGoodsAmount'],
        'totalAdditionalServiceAmount': value['totalAdditionalServiceAmount'],
        'totalTransferAmount': value['totalTransferAmount'],
        'couponAmount': value['couponAmount'],
        'totalAmount': value['totalAmount'],
        'createTime': value['createTime'],
    };
}

